import { render, staticRenderFns } from "./DeviceTag.vue?vue&type=template&id=0ea35ba7&scoped=true"
import script from "./DeviceTag.vue?vue&type=script&lang=js"
export * from "./DeviceTag.vue?vue&type=script&lang=js"
import style0 from "./DeviceTag.vue?vue&type=style&index=0&id=0ea35ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea35ba7",
  null
  
)

export default component.exports